import { connect } from 'react-redux';
import { getAppName, getMobilePlatform } from 'src/store/view/selectors';
import { getShortLink } from 'src/store/appBanners/selectors';
import {
  getDeeplinkAction,
  moveToAppContinuedWebUpper,
  moveToAppOpenedAppUpper,
  moveToAppShownUpper,
} from 'src/store/appBanners/slice';
import { TopMobileAppBannerContainer } from './TopMobileAppBannerContainer';

const mapStateToProps = (state) => ({
  linkToApp: getShortLink(state),
  platform: getMobilePlatform(state),
  appName: getAppName(state),
});

const mapDispatchToProps = {
  getDeeplink: getDeeplinkAction,
  moveToAppOpenedAppUpper,
  moveToAppShownUpper,
  moveToAppContinuedWebUpper,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(TopMobileAppBannerContainer);
